import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function JoinLeague() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, ready } = useAuth();
  const code = params.get("code") || "";

  useEffect(() => {
    if (!ready || !user) return;
    navigate(`/leghe?code=${code}`, { replace: true });
  }, [ready, user, code, navigate]);

  return (
    <div className="min-h-screen bg-[#121214] flex items-center justify-center">
      <span className="font-racing font-black text-[#FF1E27] tracking-widest animate-pulse">
        FANTASYRACE
      </span>
    </div>
  );
}
